import { EventEmitter, Input } from '@angular/core';
import { Output } from '@angular/core';
import { Component, OnInit, OnChanges } from '@angular/core';

@Component({
    selector: 'app-service-grp-select',
    templateUrl: './service-grp-select.component.html',
    styleUrls: ['./service-grp-select.component.css'],
    standalone: false
})
export class ServiceGrpSelectComponent implements OnInit, OnChanges {
  filter:any = {}
  serviceGrpOptions:any = [
    {label:"All Profession Groups" ,value: "All"},
    { label: 'Anesthesia' , value: 'Anesthesia' },
    { label: 'Nursing' , value: 'Nursing' },
    { label: 'Pharmacy' , value: 'Pharmacy' },
    { label: 'Physician' , value: 'Physician' },
    { label: 'Other' , value: 'Other' }
  ];
  selectedGroup:any;
  @Output() serviceGrpSelected = new EventEmitter<any>();
  @Input() defaultService: any ='';

  ngOnInit(): void {
    this.setSelectedGroup();
  }

  ngOnChanges(): void {
    this.setSelectedGroup();
  }

  private setSelectedGroup(): void {
    this.selectedGroup = this.defaultService && this.defaultService.length
      ? this.defaultService
      : this.serviceGrpOptions[0].value;
  }

  changeServiceGroup(serviceGroup: any){
    this.filter.serviceGroup = serviceGroup;
    this.serviceGrpSelected.emit(this.filter);
  }

  onReset(){
    this.selectedGroup = 'All';
    
  }
}
